import { render } from "./BankDetails.vue?vue&type=template&id=20af7b40"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=20af7b40&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__